









































































































































































































































import { Component, Mixins } from "vue-property-decorator";
import FixedPhraseEditTreeSelector from "./FixedPhraseEditTreeSelector.vue";
import { FixedPhraseTreeSelectorMixin } from "../mixins";
import { Directory } from "../../../../domain/drawing";
import { FixedPhraseRootReference, FixedPhraseReference, FixedPhraseComparer } from "../../../../domain/document";
import { DialogMixin } from "../../../system/mixins";
import { AiSyntaxMixin } from "../../aiPhrase/mixins";
import { FixedPhraseKinds, FixedPhraseKindsUtility } from "../";
import { FixedPhraseEditor } from "./contents";
import FixedPhraseImportDialog from "./FixedPhraseImportDialog.vue";
import { FixedPhraseEditDialogOptions } from "./FixedPhraseEditDialogOptions";

interface IFixedPhraseReferencePathInfo {
  reference: FixedPhraseReference;
  // ルートフォルダから順に、定型文のあるサブフォルダまでを格納
  path: string[];
}

@Component({
  components: {
    selector: FixedPhraseEditTreeSelector,
    FixedPhraseImportDialog,
    FixedPhraseEditor,
  }
})
export default class FixedPhraseEditDialog extends Mixins(FixedPhraseTreeSelectorMixin, DialogMixin, AiSyntaxMixin) {
  $refs!: {
    input: HTMLInputElement;
    newFixedPhraseEditor: FixedPhraseEditor;
    selector: FixedPhraseEditTreeSelector;
    importDialog: FixedPhraseImportDialog;
    fixedPhraseEditor: FixedPhraseEditor;
  };

  data(): any {
    return {
      isFolderVisible: false,
      isFixedPhraseVisible: false,
      rootFixedPhrase: null as FixedPhraseRootReference,
      defaultExpandedKeys: [],
      currentNodeKey: null,
      selectedDirectory: null as Directory<number, FixedPhraseReference>,
      selectedFixedPhrase: null as FixedPhraseReference,
      editFolderText: "",
      isAppendFolder: true,
      addFolderText: "",
      completedFixedPhrase: null as FixedPhraseRootReference,
      isFixedPhraseInitiallyEmpty: true,
      kind: null as FixedPhraseKinds,
      id: "",
      options: undefined,
      isLoading: false,
      addFixedPhraseReference: null as FixedPhraseReference,
      editFixedPhraseReference: null as FixedPhraseReference,
      newFixedPhraseEditorSelectedText: "",
      fixedPhraseEditorSelectedText: "",
    };
  }
  isFolderVisible: boolean;
  isFixedPhraseVisible: boolean;

  rootFixedPhrase: FixedPhraseRootReference;
  defaultExpandedKeys: number[];
  currentNodeKey: number;
  selectedDirectory: Directory<number, FixedPhraseReference>;
  selectedFixedPhrase: FixedPhraseReference;
  editFolderText: string;
  isAppendFolder: boolean;
  addFolderText: string;
  completedFixedPhrase: FixedPhraseRootReference;
  isFixedPhraseInitiallyEmpty: boolean;
  kind: FixedPhraseKinds;
  id: string;
  options?: FixedPhraseEditDialogOptions;
  isLoading: boolean;
  addFixedPhraseReference: FixedPhraseReference;
  editFixedPhraseReference: FixedPhraseReference;
  newFixedPhraseEditorSelectedText: string;
  fixedPhraseEditorSelectedText: string;

  get dialogTitle(): string {
    return "定型文編集";
  }

  get folderTitle(): string {
    return "フォルダ追加";
  }

  get fixedPhraseTitle(): string {
    return "定型文追加";
  }

  get preprocessButtonName(): string {
    return "{前処理}";
  }

  get preprocessButtonDescription(): string {
    return "文章生成ダイアログ表示時に実行される前処理(preprocess構文)を設定します。";
  }

  get commentSyntaxButtonName(): string {
    return "{コメント}";
  }

  get commentSyntaxButtonDescription(): string {
    return "選択部分をコメント構文化します。";
  }

  get isSelectedDirectory(): boolean {
    return this.selectedDirectory instanceof Directory;
  }

  get isSelectedFixedPhrase(): boolean {
    return this.selectedFixedPhrase instanceof FixedPhraseReference;
  }

  get isEnteredFolder(): boolean {
    return (this.addFolderText.length > 0);
  }

  get isEnteredFixedPhrase(): boolean {
    return (this.addFixedPhraseText.length > 0);
  }

  get isAddFixedPhraseOnlyPreprocess(): boolean {
    return this.isOnlyPreprocess(this.addFixedPhraseText);
  }

  get isEditFixedPhraseOnlyPreprocess(): boolean {
    return this.isOnlyPreprocess(this.editFixedPhraseText);
  }

  get defaultFolderName(): string {
    return FixedPhraseKindsUtility.isAiPhrase(this.kind)
      ? this.$configuration.behavior.document.editor.contents.aiPhrase.defaultFolderName
      : this.$configuration.behavior.document.editor.contents.fixedPhrase.defaultFolderName;
  }

  get phraseEditDescription(): string {
    return this.options && this.options.phrase && this.options.phrase.description
      ? this.options.phrase.description
      : "";
  }

  get descriptionClass(): string {
    return this.phraseEditDescription
      ? "long-sentence"
      : "";
  }

  get isTestEnable(): boolean {
    return this.options && this.options.phrase && !!this.options.phrase.test;
  }

  get isCreateSyntaxEnable(): boolean {
    return this.options && this.options.phrase && !!this.options.phrase.createSyntax;
  }

  get isEditPreprocessEnable(): boolean {
    return this.options && this.options.phrase && !!this.options.phrase.editPreprocess;
  }

  get isCreateCommentSyntaxEnable(): boolean {
    return this.options && this.options.phrase && !!this.options.phrase.createCommentSyntax;
  }

  get addFixedPhraseTitle(): string {
    return this.addFixedPhraseReference
      ? this.addFixedPhraseReference.name
      : "";
  }

  set addFixedPhraseTitle(value: string) {
    if (this.addFixedPhraseReference) {
      this.addFixedPhraseReference.name = value;
    }
  }

  get addFixedPhraseText(): string {
    return this.addFixedPhraseReference
      ? this.addFixedPhraseReference.text
      : "";
  }

  set addFixedPhraseText(value: string) {
    if (this.addFixedPhraseReference) {
      this.addFixedPhraseReference.text = value;
    }
  }

  get editFixedPhraseTitle(): string {
    return this.editFixedPhraseReference
      ? this.editFixedPhraseReference.name
      : "";
  }

  set editFixedPhraseTitle(value: string) {
    if (this.editFixedPhraseReference) {
      this.editFixedPhraseReference.name = value;
    }
  }

  get editFixedPhraseText(): string {
    return this.editFixedPhraseReference
      ? this.editFixedPhraseReference.text
      : "";
  }

  set editFixedPhraseText(value: string) {
    if (this.editFixedPhraseReference) {
      this.editFixedPhraseReference.text = value;
    }
  }

  async show(rootReference: FixedPhraseRootReference, defaultExpandedKeys: number[], currentNodeKey: number, latest: FixedPhraseRootReference, kind: FixedPhraseKinds, id: string, options?: FixedPhraseEditDialogOptions): Promise<FixedPhraseRootReference> {
    return this.showModal(async () => {
      const useCurrentTree = !latest || FixedPhraseComparer.isSameTree(rootReference, latest);
      this.rootFixedPhrase = useCurrentTree ? rootReference.clone() : latest;
      this.defaultExpandedKeys = useCurrentTree ? defaultExpandedKeys : [];
      this.currentNodeKey = useCurrentTree ? currentNodeKey : null;
      this.isFixedPhraseInitiallyEmpty = (this.rootFixedPhrase.folders.length < 1);
      this.kind = kind;
      this.id = id;
      this.options = options;

      // ルートフォルダがない場合、デフォルトのフォルダを追加して選択状態とする
      if (this.rootFixedPhrase.folders.length < 1
          && this.defaultFolderName) {
        // ツリーのキーは毎回生成され、ルートフォルダは必ず1となるので1指定
        this.currentNodeKey = 1;
        this.$nextTick(() => {
          const selector = this.$refs.selector as FixedPhraseEditTreeSelector;
          selector.addFolder(this.defaultFolderName, this.isAppendFolder);
        });
      }

      // フォルダ選択されていない場合、ルートフォルダが1つだけならルートフォルダを選択
      if (!this.currentNodeKey && this.rootFixedPhrase.folders.length === 1) {
        // ツリーのキーは毎回生成され、ルートフォルダは必ず1となるので1指定
        this.defaultExpandedKeys = [1];
        this.currentNodeKey = 1;
      }

      this.completedFixedPhrase = null;
      await this.waitHidden();
      this.clear();
      return this.completedFixedPhrase;
    });
  }

  clear(): void {
    this.rootFixedPhrase = null;
    this.defaultExpandedKeys = [];
    this.currentNodeKey = null;
    this.selectedDirectory = null;
    this.selectedFixedPhrase = null;
    this.editFolderText = "";
    this.editFixedPhraseReference = null;
  }

  inputDirectory(value: Directory<number, FixedPhraseReference>): void {
    this.selectedDirectory = value;
    this.editFolderText = (this.selectedDirectory !== null)
      ? this.selectedDirectory.name
      : "";
  }

  inputFixedPhrase(value: FixedPhraseReference): void {
    this.selectedFixedPhrase = value;
    this.editFixedPhraseReference = (this.selectedFixedPhrase !== null)
      ? this.selectedFixedPhrase
      : null;
  }

  showAddFolder(isAppend: boolean): void {
    this.addFolderText = "";
    this.isFolderVisible = true;
    this.isAppendFolder = isAppend;
    this.$nextTick(() => {
      const element = this.$refs.input as HTMLInputElement;
      element.focus();
    });
  }

  addFolder(): void {
    if (!this.addFolderText || this.addFolderText === "") { return; }
    if (!this.isFolderVisible) { return; } // Enter連続押下やダブルクリックで意図せずフォルダが複数追加されるのを防ぐ
    const selector = this.$refs.selector as FixedPhraseEditTreeSelector;
    selector.addFolder(this.addFolderText, this.isAppendFolder);
    this.isFolderVisible = false;
  }

  cancelFolder(): void {
    this.isFolderVisible = false;
  }

  deleteFolder(): void {
    const selector = this.$refs.selector as FixedPhraseEditTreeSelector;
    selector.deleteFolder();
    this.selectedDirectory = null;
    this.editFolderText = "";
  }

  showAddFixedPhrase(): void {
    this.addFixedPhraseReference = new FixedPhraseReference("", "");
    this.isFixedPhraseVisible = true;
    this.$nextTick(() => {
      this.$refs.newFixedPhraseEditor.focusTitle();
    });
  }

  isExportable(data: FixedPhraseRootReference): boolean {
    return data && data.folders && data.folders.length > 0 && data.folders.some(d => this.hasFixedPhrase(d));
  }

  async exportFixedPhrase(): Promise<void> {
    try {
      this.isLoading = true;
      const latestData = await this.getFixedPhrase(this.kind, this.id);
      if (!this.isExportable(latestData)) {
        this.$error("エクスポート中止", "エクスポートできる定型文がありません。");
        return;
      }

      const index = await this.confirmToExport();
      if (index === 2) { return; }
      await this.exportAndDownloadFixedPhrase(this.kind, this.id, (index === 1));
    } finally {
      this.isLoading = false;
    }
  }

  private hasFixedPhrase(directory: Directory<number, FixedPhraseReference>): boolean {
    return directory.entities.some(e => !!e.text)
      || directory.nodes.some(n => this.hasFixedPhrase(n));
  }

  private async confirmToExport(): Promise<number> {
    return this.$commonDialogs.confirmation.show({
      message: [
        "出力形式を選択してください。",
        "",
        "■CSV形式",
        "Excel等で編集可能ですが、",
        "同じフォルダ名のフォルダは同一と見なされる制約があります。",
        "",
        "■JSON形式",
        "Excel等で簡単に編集する事はできませんが、",
        "制約は特になく構造を完全に再現できます。"
      ],
      buttons: [
        {
          kind: "confirm",
          label: "CSVで出力する",
        },
        {
          kind: "confirm",
          label: "JSONで出力する",
        },
        {
          kind: "cancel",
          label: "中止する",
        },
      ],
    });
  }

  async showFixedPhraseImportDialog(): Promise<void> {
    const result = await this.$refs.importDialog.show();
    const selector = this.$refs.selector as FixedPhraseEditTreeSelector;
    selector.import(result);
  }

  addFixedPhrase(): void {
    if (!this.addFixedPhraseText || this.addFixedPhraseText === "") { return; }
    if (!this.isFixedPhraseVisible) { return; } // ダブルクリックで意図せず定型文が複数追加されるのを防ぐ
    const selector = this.$refs.selector as FixedPhraseEditTreeSelector;
    selector.addFixedPhrase(this.addFixedPhraseTitle, this.addFixedPhraseText);
    this.isFixedPhraseVisible = false;
  }

  cancelFixedPhrase(): void {
    this.isFixedPhraseVisible = false;
  }

  deleteFixedPhrase(): void {
    const selector = this.$refs.selector as FixedPhraseEditTreeSelector;
    selector.deleteFixedPhrase();
    this.selectedFixedPhrase = null;
    this.editFixedPhraseReference = null;
  }

  save(): void {
    const selector = this.$refs.selector as FixedPhraseEditTreeSelector;
    const currentFixedPhrase = selector.createFixedPhrase();

    // いずれかの定型文が空、生成AI定型文の場合は加えて前処理構文のみで構成される場合、登録を中止する
    // 修正時時点では定型文は空にならない為、生成AI定型文のみで中止されうる
    const pathInfo = this.getReferencePathInfo(currentFixedPhrase);
    for (const info of pathInfo) {
      if (!info.reference.text || this.isOnlyPreprocess(info.reference.text)) {
        this.$warn("登録中止", this.getRegisterWarningText(!!this.options, info));
        return;
      }
    }

    this.confirmSave(currentFixedPhrase)
      .then(result => {
        if (!result) { return; }
        
        this.completedFixedPhrase = currentFixedPhrase;
        this.isVisible = false;
      });
  }

  getReferencePathInfo(root: FixedPhraseRootReference): IFixedPhraseReferencePathInfo[] {
    const result = [] as IFixedPhraseReferencePathInfo[];
    for (const folder of root.folders) {
      this.addReferencePathInfo(folder, [], result);
    }

    return result;
  }

  addReferencePathInfo(
    directory: Directory<number, FixedPhraseReference>,
    path: string[] = [],
    result: IFixedPhraseReferencePathInfo[] = []): void {
    const currentPath = [...path, directory.name];
    for (const reference of directory.entities) {
      result.push({ reference: reference, path: currentPath });
    }

    for (const child of directory.nodes) {
      this.addReferencePathInfo(child, currentPath, result);
    }
  }

  getRegisterWarningText(hasOptions: boolean, info: IFixedPhraseReferencePathInfo): string {
    const expressionString = hasOptions
      ? "空、もしくは{前処理}構文だけの定型文テンプレートがあります。"
      : "空の定型文テンプレートがあります。";
    const pathString = info.path.join(" > ");

    const hasName = !!info.reference.name.trim();
    if (!hasOptions || (!hasName && !info.reference.text.trim())) {
      return expressionString
        + (pathString.length > 60 ? pathString.slice(0, 60) + "..." : pathString);
    }

    const referenceString =  " > " + (hasName ? info.reference.name : info.reference.text);
    const pathAndReferenceString = pathString + referenceString;
    return expressionString
      + (pathAndReferenceString.length > 60 ? pathAndReferenceString.slice(0, 60) + "..." : pathAndReferenceString);
  }

  async cancelEdit(): Promise<void> {
    if (await this.confirmClose()) {
      this.isVisible = false;
    }
  }

  async beforeClose(done: () => void): Promise<void> {
    if (await this.confirmClose()) {
      done();
    }
  }

  private async confirmSave(currentFixedPhrase: FixedPhraseRootReference): Promise<boolean> {
    const isEmpty = !currentFixedPhrase || (currentFixedPhrase.folders.length === 0);
    
    // 京大で定型文を登録した時消えてしまうというユーザクレーム向けの暫定対処用の実装.
    // 編集操作をした以上データはあるはずだがデータが空のケース以外で空で登録されるのは実装を見る限りありえない.
    // 再現できてないが再現した場合は空で更新できなくするdanger-zone設定を追加して回避.
    if (isEmpty && this.$configuration.dangerZone.document.editor.fixedPhrase.emptyRegistrationGuard.isEnable) {
      this.$error("更新失敗", this.$configuration.dangerZone.document.editor.fixedPhrase.emptyRegistrationGuard.wording);
      return false;
    }

    if (this.isFixedPhraseInitiallyEmpty || !isEmpty) { return true; }

    // 編集開始時に定型文が存在していて、空の定型文を登録しようとしている際は確認ダイアログ表示
    // （フォルダ追加や定型文追加して保存したときに、定型文がすべてクリアされてしまった事象を防ぐための対応）
    const index = await this.$commonDialogs.confirmation.confirmSaveCancel(
      "確認",
      ["定型文がすべて削除されていますが、よろしいですか？"]
    );
    return (index === 0);
  }

  private async confirmClose(): Promise<boolean> {
    const selector = this.$refs.selector as FixedPhraseEditTreeSelector;
    if (!selector.hasEdited()) {
      return true;
    }
    const index = await this.$commonDialogs.confirmation.confirmDestructCancel(
      "確認",
      ["編集中の内容を破棄しますが、よろしいですか？"]
    );
    return (index === 0);
  }

  async test(text: string): Promise<void> {
    if (!this.isTestEnable) { return; }
    await this.options.phrase.test(text);
  }

  replaceAddFixedPhraseText(): void {
    if (!this.isCreateCommentSyntaxEnable) { return; }
    const selectionStart = this.$refs.newFixedPhraseEditor.getTextareaSelectionStart();
    const selectionEnd = this.$refs.newFixedPhraseEditor.getTextareaSelectionEnd();
    const syntax = this.options.phrase.createCommentSyntax(this.newFixedPhraseEditorSelectedText);
    this.addFixedPhraseText = this.mergeFixedPhrase(this.addFixedPhraseText, syntax, selectionStart, selectionEnd);

    this.$refs.newFixedPhraseEditor.focusTextarea();
    this.$nextTick(() => {
      this.$refs.newFixedPhraseEditor.setTextareaSelectionRange(selectionStart, selectionStart + syntax.length);
    });
  }

  replaceEditFixedPhraseText(): void {
    if (!this.isCreateCommentSyntaxEnable) { return; }
    const selectionStart = this.$refs.fixedPhraseEditor.getTextareaSelectionStart();
    const selectionEnd = this.$refs.fixedPhraseEditor.getTextareaSelectionEnd();
    const syntax = this.options.phrase.createCommentSyntax(this.fixedPhraseEditorSelectedText);
    this.editFixedPhraseText = this.mergeFixedPhrase(this.editFixedPhraseText, syntax, selectionStart, selectionEnd);

    this.$refs.fixedPhraseEditor.focusTextarea();
    this.$nextTick(() => {
      this.$refs.fixedPhraseEditor.setTextareaSelectionRange(selectionStart, selectionStart + syntax.length);
    });
  }

  async insertSyntaxInAddFixedPhraseText(defaultKeyword: string): Promise<void> {
    const selectionStart = this.$refs.newFixedPhraseEditor.getTextareaSelectionStart();
    const selectionEnd = this.$refs.newFixedPhraseEditor.getTextareaSelectionEnd();
    const syntax = await this.options.phrase.createSyntax(defaultKeyword);
    if (syntax || (!syntax && !defaultKeyword)) {
      this.addFixedPhraseText = this.mergeFixedPhrase(this.addFixedPhraseText, syntax, selectionStart, selectionEnd);
    }

    this.$refs.newFixedPhraseEditor.focusTextarea();
    this.$nextTick(() => {
      this.$refs.newFixedPhraseEditor.setTextareaSelectionRange(selectionStart, selectionStart + syntax.length);
    });
  }

  async insertSyntaxInEditFixedPhraseText(defaultKeyword: string): Promise<void> {
    const selectionStart = this.$refs.fixedPhraseEditor.getTextareaSelectionStart();
    const selectionEnd = this.$refs.fixedPhraseEditor.getTextareaSelectionEnd();
    const syntax = await this.options.phrase.createSyntax(defaultKeyword);
    if (syntax || (!syntax && !defaultKeyword)) {
      this.editFixedPhraseText = this.mergeFixedPhrase(this.editFixedPhraseText, syntax, selectionStart, selectionEnd);
    }

    this.$refs.fixedPhraseEditor.focusTextarea();
    this.$nextTick(() => {
      this.$refs.fixedPhraseEditor.setTextareaSelectionRange(selectionStart, selectionStart + syntax.length);
    });
  }

  mergeFixedPhrase(source: string, extraSource: string, selectionStart: number, selectionEnd: number): string {
    const index = (selectionStart !== undefined) ? selectionStart : source.length;
    return source.slice(0, index) + extraSource + source.slice(Math.max(index, selectionEnd));
  }

  onNewEditorAiSyntaxButtonDragStarted(event: DragEvent) {
    if (!this.isCreateSyntaxEnable) { return; }
    if (this.isIe) {
      // IE以外はドロップ時に「{AI構文}」を定型文に追加して「{AI構文}」が選択状態になる
      // 構文を選択したら「{AI構文}」を置換し、選択しなければ「{AI構文}」を削除する
      // IEは「{AI構文}」を追加しない（AiSyntaxMixin.onSyntaxButtonDragStarted）
      // 置換も削除もしないようにしたいので、選択状態を解除しておく
      this.$refs.newFixedPhraseEditor.clearSelection();
    }
    this.onSyntaxButtonDragStarted(event);
  }

  onEditorAiSyntaxButtonDragStarted(event: DragEvent) {
    if (!this.isCreateSyntaxEnable) { return; }
    if (this.isIe) {
      // IE以外はドロップ時に「{AI構文}」を定型文に追加して「{AI構文}」が選択状態になる
      // 構文を選択したら「{AI構文}」を置換し、選択しなければ「{AI構文}」を削除する
      // IEは「{AI構文}」を追加しない（AiSyntaxMixin.onSyntaxButtonDragStarted）
      // 置換も削除もしないようにしたいので、選択状態を解除しておく
      this.$refs.fixedPhraseEditor.clearSelection();
    }
    this.onSyntaxButtonDragStarted(event);
  }

  async onNewPhraseEditorDropped() {
    if (!this.isCreateSyntaxEnable) { return; }
    await this.insertSyntaxInAddFixedPhraseText("");
  }

  async onPhraseEditorDropped(): Promise<void> {
    if (!this.isCreateSyntaxEnable) { return; }
    await this.insertSyntaxInEditFixedPhraseText("");
  }

  onNewFixedPhraseEditorSelectionChanged(selectedText: string): void {
    this.newFixedPhraseEditorSelectedText = selectedText;
  }

  onFixedPhraseEditorSelectionChanged(selectedText: string): void {
    this.fixedPhraseEditorSelectedText = selectedText;
  }
  
  async insertPreprocessInAddFixedPhraseText(): Promise<void> {
    const preprocessAddedText = await this.extractAndTransformPreprocess(
      this.addFixedPhraseText,
      (t: string) => this.options.phrase.editPreprocess(t)
    );
    this.addFixedPhraseText = preprocessAddedText;
  }

  async insertPreprocessInEditFixedPhraseText(): Promise<void> {
    const preprocessEditedText = await this.extractAndTransformPreprocess(
      this.editFixedPhraseText,
      (t: string) => this.options.phrase.editPreprocess(t)
    );
    this.editFixedPhraseText = preprocessEditedText;
  }

  async extractAndTransformPreprocess(input: string, transformPreprocess: (block: string) => Promise<string>): Promise<string> {
    // inputから前処理部分を抽出して削除し、transformPreprocessで変換したものを先頭に持ってくる
    const { cleaned, extracted } = this.cleanAndExtractPreprocess(input);

    const transformedHeader = await transformPreprocess(extracted);

    return transformedHeader !== undefined ? `${transformedHeader}${cleaned}` : input;
  }
  
  cleanAndExtractPreprocess(input: string): { cleaned: string, extracted: string } {
    const expressionPrefix = "{[ \r\n\t]*preprocess[ \r\n\t]*\\?[ \r\n\t]*{";
    const expressionSuffix = "}[ \r\n\t]*}[ \r\n\t]*";
    // JSON内のネストは単体版に合わせて1段階まで対応させる
    const expression = new RegExp(expressionPrefix + "[^{}]*({[^{}]*})*" + expressionSuffix, "g");

    const match = expression.exec(input);
    if (!match) { return { cleaned: input, extracted: "" }; }

    const extracted = match[0];
    const startIndex = match.index;
    const endIndex = startIndex + extracted.length;

    // 前処理構文後続の空白・改行を削除する
    const afterPreprocess = input.slice(endIndex);
    const trailingBlankMatch = afterPreprocess.match(/^([\s]*)/);
    const trailingBlankLength = trailingBlankMatch ? trailingBlankMatch[0].length : 0;

    const cleaned = input.slice(0, startIndex) + input.slice(endIndex + trailingBlankLength);

    return { cleaned, extracted };
  }

  isOnlyPreprocess(input: string): boolean {
    if (!this.options) { return false; }
    const { cleaned, extracted } = this.cleanAndExtractPreprocess(input);
    return !!extracted && !cleaned.trim(); 
  }
}
